/**
 * Created by WorkAxis www.workaxis.in
 * Developer: Padma Dev.E
 * Developer Contact: padmadev.e@workaxis.in
 * Admin: shyam@workaxis.in
 * Date: 3/14/2022
 * Time: 4:37 PM
 * Project: w_crm
 */

// Cookies have a ~4KB size limit. Chunking allows us to store larger strings.
const CHUNK_SIZE = 3800;

function setBaseCookie(name, value, days) {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  // Note: We use path=/ to ensure visibility across the app
  document.cookie = name + "=" + (value || "") + expires + "; path=/; SameSite=Lax";
}

function getBaseCookie(name) {
  const nameEQ = name + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseBaseCookie(name) {
  document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
}

/**
 * Sets a cookie. If the value is too large, it splits it into multiple chunked cookies.
 */
export function setCookie(name, value, days) {
  // First, clear any existing chunks for this cookie name
  eraseCookie(name);

  if (!value) return;

  if (value.length <= CHUNK_SIZE) {
    setBaseCookie(name, value, days);
  } else {
    const totalChunks = Math.ceil(value.length / CHUNK_SIZE);
    // Store the number of chunks in the main cookie
    setBaseCookie(name, `chunked:${totalChunks}`, days);

    for (let i = 0; i < totalChunks; i++) {
      const start = i * CHUNK_SIZE;
      const chunk = value.substring(start, start + CHUNK_SIZE);
      setBaseCookie(`${name}_${i}`, chunk, days);
    }
  }
}

/**
 * Retrieves a cookie, automatically reassembling it if it was chunked.
 */
export function getCookie(name) {
  const mainVal = getBaseCookie(name);

  if (mainVal && mainVal.startsWith("chunked:")) {
    const totalChunks = parseInt(mainVal.split(":")[1], 10);
    let fullValue = "";
    for (let i = 0; i < totalChunks; i++) {
      const chunk = getBaseCookie(`${name}_${i}`);
      if (chunk) {
        fullValue += chunk;
      } else {
        // If a chunk is missing, the data is corrupted
        return null;
      }
    }
    return fullValue;
  }

  return mainVal;
}

/**
 * Erases a cookie and all of its possible chunks.
 */
export function eraseCookie(name) {
  const mainVal = getBaseCookie(name);

  if (mainVal && mainVal.startsWith("chunked:")) {
    const totalChunks = parseInt(mainVal.split(":")[1], 10);
    for (let i = 0; i < totalChunks; i++) {
      eraseBaseCookie(`${name}_${i}`);
    }
  }

  eraseBaseCookie(name);
}
